<template>
	<section class="news-section">
		<div class="news-section__container">
			<h2
				:data-aos="disableAos ? undefined : 'fade-up'"
				class="news-section__title text-display"
				v-html="detectNewline($t('components.news.section.newest_news'))"></h2>
			<Swiper
				v-if="fetchedNews && fetchedNews?.length > 0"
				class="news-section__swiper"
				:slidesPerView="'auto'"
				:space-between="16"
				@after-init="
					(swiper) => {
						useTimeoutFn(() => {
							swiper.slideNext(0)
							swiper.slidePrev(0)
						}, 400)
					}
				">
				<SwiperSlide v-for="post in fetchedNews" :key="post.id" class="news-section__swiper-slide">
					<NewsCard :key="post.id" :post="post" />
				</SwiperSlide>
				<GlobalNewsSwiperNav />
			</Swiper>
			<Swiper
				v-else
				class="news-section__swiper"
				:slidesPerView="'auto'"
				:space-between="16"
				@after-init="
					(swiper) => {
						useTimeoutFn(() => {
							swiper.slideNext(0)
							swiper.slidePrev(0)
						}, 400)
					}
				">
				<SwiperSlide v-for="i in 10" :key="i" class="news-section__swiper-slide">
					<NewsCardPlaceholder />
				</SwiperSlide>
				<GlobalNewsSwiperNav />
			</Swiper>
			<div class="news-section__more-btn-wrapper">
				<ButtonPrimary :to="localePath('blog')" class="news-section__more-btn">
					{{ $t('components.news.section.see_all') }}
				</ButtonPrimary>
			</div>
		</div>
	</section>
</template>

<script setup lang="ts">
const fetchedNews = ref<Partial<INewsModel>[]>()
// const i18nService = usei18nService()
// const localeLang = i18nService.getLocaleLang()
const localePath = useLocalePath()

const newsStore = useNewsStore()

onMounted(async () => {
	fetchedNews.value = await newsStore.fetchLastNews()
})

defineProps<{
	disableAos?: boolean
}>()
</script>

<style lang="scss" src="./Section.scss"></style>
